const fullShop = {
  products: [],
  navCategories: [],
  categoryName: "",
  currencies: {
    navCurrencies: [],
    selectedCurrency: "$",
  },
  Active: "",
  prices: [],
  displayPrice: [],
  loadPrice: true,
  showCurrencyList: false,
  showCartOverlay: false,
  singleProductId: "",
  generatedId: "",
  selectedproduct: {},
  cart: {},
  cartTotal: 0,
  itemsInCart: 0,
  totalCartProductQuantity: 0,
  tax: 0,
};

export default fullShop;
